// extracted by mini-css-extract-plugin
module.exports = {"reactivateLink":"reactivate-link_reactivateLink__0Zh6_"};